import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  isAnalyticsEnabled,
  resetScrollTracking,
  scheduleAnalyticsLoad,
  setupAnalyticsAutoTracking,
  trackPageView,
  waitForGtagReady,
} from "@/lib/analytics";

/** GA4: index.html Google Tag + SPA page_view + gtag hazır olunca etkileşim olayları. */
export function GoogleAnalytics() {
  const { pathname, search } = useLocation();
  const lastPath = useRef<string | null>(null);
  useEffect(() => {
    if (!isAnalyticsEnabled()) return;
    scheduleAnalyticsLoad();
    setupAnalyticsAutoTracking();
  }, []);

  useEffect(() => {
    if (!isAnalyticsEnabled()) return;

    const path = `${pathname}${search}`;
    if (lastPath.current === path) return;
    lastPath.current = path;
    resetScrollTracking();

    void waitForGtagReady().then(() => {
      trackPageView(path, document.title);
    });
  }, [pathname, search]);

  return null;
}
